import getDomainNumber from 'rebook/apps/utils/urls/getDomainNumber';


export default (src, width, height, options = {}) => {
  const size = options.size || 1;
  const type = options.type || 'cropped';

  const staticDomains = STATIC_DOMAINS;
  const imageType = {
    cropped: 'c',
    resized: 'p',
  }[type];

  // normalize already cropped or resized images
  const originalSrc = src.replace(/^(https?:\/\/.+)?\/[cp]\/[\dx]+\//, '');
  const domain = staticDomains[getDomainNumber(originalSrc, staticDomains)];

  width = width * size || '';
  height = height * size || '';

  return `https://${domain}/${imageType}/${width}x${height}/${originalSrc}`;
};
